document.addEventListener("DOMContentLoaded", async function () {
  // 1) Ürün JSON linki
  const productJsonUrl = window.location.pathname.replace(/\/$/, "") + ".js";

  // 2) DOM elemanları
  const anyForm =
    document.querySelector('form[action^="/cart/add"]') ||
    document.querySelector("form");

  const addBtn =
    document.querySelector("#AddToCart.pro-cart") ||
    (anyForm && anyForm.querySelector('button[type="submit"], input[type="submit"]')) ||
    document.querySelector('button[type="submit"], input[type="submit"]');

  const buyNowBtn =
    document.querySelector(".product-details .shopify-payment-button__button") ||
    document.querySelector(".shopify-payment-button__button");

  const variantIdField =
    (anyForm && anyForm.querySelector('[name="id"]')) ||
    document.querySelector('[name="id"]');

  // Add to Cart buton metni TR
  if (addBtn && (addBtn.textContent || "").toLowerCase().includes("add")) {
    addBtn.textContent = "Sepete Ekle";
  }

  const setButtonsEnabled = (enabled) => {
    [addBtn, buyNowBtn].forEach((btn) => {
      if (!btn) return;
      btn.disabled = !enabled;
      btn.style.opacity = enabled ? "" : "0.6";
      btn.style.cursor = enabled ? "" : "not-allowed";
    });
  };

  // 3) Ürün JSON çek
  let product;
  try {
    const res = await fetch(productJsonUrl, { credentials: "same-origin" });
    if (!res.ok) {
      // JSON yoksa butonları kapatma
      setButtonsEnabled(true);
      return;
    }
    product = await res.json();
  } catch (e) {
    setButtonsEnabled(true);
    return;
  }

  const variants = product.variants || [];
  const requiresShipping = variants.some((v) => v.requires_shipping);
  

  // 4) Dijital ürünse "Kargolu Ürün" alanını gizle
  // 4) Fiziksel/Dijital bilgisini doğru göster
const shippingInfoBlock = document.querySelector(".product_additional_information");

if (shippingInfoBlock) {
  const infoBtn = shippingInfoBlock.querySelector("button");

  if (infoBtn) {
    if (requiresShipping) {
      infoBtn.textContent = "Kargolu Ürün";
      shippingInfoBlock.style.display = ""; // görünür kalsın
    } else {
      infoBtn.textContent = "Dijital Ürün";
      shippingInfoBlock.style.display = ""; // gizleme yok
    }
  } else {
    // button yoksa direkt blok içeriğini yönet
    shippingInfoBlock.style.display = "";
    if (!requiresShipping) shippingInfoBlock.textContent = "Dijital Ürün";
  }
}

  // 5) Tek varyant / variantsız ürün: butonlar her zaman açık
  if (variants.length <= 1) {
    setButtonsEnabled(true);
    return;
  }

  // 6) Çok varyantlı ürün: Süre select'i bul
  const optionSelect = document.querySelector("#productSelect-option-0");

  // Eğer bu ürün çok varyantlı ama select yoksa, güvenli tarafta kal: butonları kapatma
  if (!optionSelect) {
    setButtonsEnabled(true);
    return;
  }

  // Inline uyarı alanı
  const wrapper = optionSelect.closest(".selector-wrapper") || optionSelect.parentElement;
  let errorEl = document.getElementById("duration-error");
  if (!errorEl) {
    errorEl = document.createElement("div");
    errorEl.id = "duration-error";
    errorEl.style.cssText =
      "margin-top:8px;font-size:12px;font-weight:700;color:#e11d48;display:none;";
    wrapper.appendChild(errorEl);
  }

  const showError = (msg) => {
    errorEl.textContent = msg || "Lütfen süre seçiniz.";
    errorEl.style.display = "block";
  };
  const hideError = () => {
    errorEl.style.display = "none";
  };

  const fmt = (cents) =>
    (cents / 100).toLocaleString("tr-TR", { maximumFractionDigits: 0 }) + " TL";

  // 7) Placeholder ekle (yoksa)
  if (!optionSelect.querySelector('option[value=""]')) {
    const ph = document.createElement("option");
    ph.value = "";
    ph.textContent = "Lütfen süre seçiniz";
    ph.disabled = true;
    ph.selected = true;
    optionSelect.insertBefore(ph, optionSelect.firstChild);
  }

  // 8) Option metinlerine fiyat ekle (placeholder hariç)
  optionSelect.querySelectorAll("option").forEach((opt) => {
    if (opt.value === "") return;

    const base = opt.getAttribute("data-base-label") || opt.textContent.trim();
    opt.setAttribute("data-base-label", base);

    const v = variants.find((vv) => (vv.option1 || "").trim() === base);
    if (v) opt.textContent = `${base} — ${fmt(v.price)}`;
  });

  // 9) Sayfa açılınca seçim yok: butonlar kapalı
  optionSelect.value = "";
  if (variantIdField) variantIdField.value = "";
  setButtonsEnabled(false);

  // 10) Değişince aç/kapat
  optionSelect.addEventListener("change", () => {
    const ok = optionSelect.value && optionSelect.value !== "";
    if (ok) {
      hideError();
      setButtonsEnabled(true);
    } else {
      setButtonsEnabled(false);
      showError("Lütfen süre seçiniz.");
      if (variantIdField) variantIdField.value = "";
    }
  });

  // 11) Submit’te kontrol
  if (anyForm) {
    anyForm.addEventListener("submit", (e) => {
      const ok = optionSelect.value && optionSelect.value !== "";
      if (!ok) {
        e.preventDefault();
        showError("Lütfen süre seçiniz.");
        optionSelect.focus();
        setButtonsEnabled(false);
      }
    });
  }
});
// Açıklamaya Devamını Gör linki ekle
document.addEventListener("DOMContentLoaded", function(){

  const desc =
    document.querySelector(".product-description") ||
    document.querySelector(".product-desc") ||
    document.querySelector(".product__description") ||
    document.querySelector(".pro-desc");

  if(!desc) return;

  const btn = document.createElement("div");
  btn.className = "read-more-desc";
  btn.textContent = "Devamını Gör";

  desc.after(btn);

  btn.addEventListener("click", function(){

    const target =
      document.querySelector("#tab-description") ||
      document.querySelector(".product-tabs") ||
      document.querySelector("#description");

    if(target){
      target.scrollIntoView({behavior:"smooth"});
    }

  });

});
// Add to cart popup Türkçeleştirme
// Add to cart popup Türkçeleştirme + doğru sepet toplamı
document.addEventListener("click", function () {
  setTimeout(async function () {
    const modal = document.querySelector("#modalAddToCart");
    if (!modal) return;

    // Başarı mesajı
    const successText =
      modal.querySelector(".modal-content-text h4") ||
      modal.querySelector(".modal-content-text");

    if (successText) {
      successText.textContent = "Ürün başarıyla sepete eklendi!";
    }

    // Butonlar
    const buttons = modal.querySelectorAll(".continue_btn a");

    if (buttons[0]) buttons[0].textContent = "Sepete Git";
    if (buttons[1]) buttons[1].textContent = "Ödemeye Geç";

    // Sepet bilgisi ve toplam tutarı Shopify'dan doğru çek
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      const cart = await res.json();

      const itemCount = modal.querySelector(".total_item");
      if (itemCount) {
        itemCount.textContent = "Sepetinizde " + cart.item_count + " ürün var.";
      }

      const total = modal.querySelector(".cart_total");
      if (total) {
        const formattedTotal = (cart.total_price / 100).toLocaleString("tr-TR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }) + " TL";

        total.textContent = "Toplam Tutar: " + formattedTotal;
      }
    } catch (e) {
      console.log("Sepet bilgisi alınamadı", e);
    }

  }, 600);
});